import {
  Button,
  IconButton,
  ListItemAvatar,
  ListItemSecondaryAction,
  MenuItem,
  Theme,
  Typography,
  createStyles,
} from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";
import { makeStyles } from "@material-ui/styles";
import {
  RubkFaturamentoIcon,
  RubkOrcamentoIcon,
} from "assets/icons/CustomSVGIcons";
import clsx from "clsx";
import { SimpleMenu } from "components/UI/Menus";
import { useState } from "react";
import { UserStore } from "store";
import { lang } from "../../../i18nLang";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 337,
      minHeight: 167,
    },
    menuButton: {
      color: theme.palette.white,
      fontSize: "1.5rem",
      padding: theme.spacing(2),
      marginRight: theme.spacing(1),
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.3)",
      },
    },
    menuButtonActive: {
      backgroundColor: "rgba(255,255,255,0.3)",
    },
    menuItem: {
      paddingTop: "0.9rem",
      paddingBottom: "0.9rem",
    },
    title: {
      margin: theme.spacing(0, 0, 0, 4),
      fontWeight: 700,
      color: theme.palette.gray[800],
    },
    text: {
      fontSize: "0.85rem",
      fontWeight: 700,
      color: theme.palette.gray[800],
    },
    avatar: { minWidth: 32, height: 32, marginRight: theme.spacing(2) },
    buttonOrcamento: {
      backgroundColor: "#9AAF00",
      "&:hover": {
        backgroundColor: "#586400 !important",
      },
    },
  })
);

interface IMenuProductsItemProps {
  description: string;
  Icon: any;
  link?: string;
  subscribeLink: string;
  onClick?: (ev) => void;
  buttonClassName?: any;
  showLicense: boolean;
}

const MenuProductsItem = ({
  description,
  Icon,
  link,
  subscribeLink,
  onClick,
  buttonClassName,
  showLicense,
}: IMenuProductsItemProps) => {
  const classes = useStyles();
  const props = link ? { component: "a", target: "_blank", href: link } : {};

  return (
    <MenuItem {...props} className={classes.menuItem} onClick={onClick}>
      <ListItemAvatar className={classes.avatar}>
        <Icon />
      </ListItemAvatar>
      <Typography className={classes.text}>{description}</Typography>
      {showLicense && (
        <ListItemSecondaryAction>
          <Button
            size="small"
            variant="contained"
            color="primary"
            target="_blank"
            href={subscribeLink}
            classes={buttonClassName && { containedPrimary: buttonClassName }}
          >
            {lang("subscribeNow")}
          </Button>
        </ListItemSecondaryAction>
      )}
    </MenuItem>
  );
};

const MenuProducts = () => {
  const userPermissions = UserStore.currentUser?.products;

  const classes = useStyles();
  const [anchor, setAnchor] = useState(null);
  const subscribeLink = "https://www.rubk.com.br";
  const orcamentoLink = "https://rubk.app";

  const handleOpen = (event) => setAnchor(event.currentTarget);
  const handleClose = () => setAnchor(null);
  return (
    <>
      <IconButton
        className={clsx(classes.menuButton, {
          [classes.menuButtonActive]: Boolean(anchor),
        })}
        // onClick={handleOpen}
      >
        <AppsIcon />
      </IconButton>
      <SimpleMenu
        open={Boolean(anchor)}
        anchorEl={anchor}
        keepMounted
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        elevation={3}
        classes={{ list: classes.root }}
      >
        <Typography variant="h6" className={classes.title}>
          {lang("apps")}
        </Typography>
        <MenuProductsItem
          description={"Rubk Faturamento"}
          Icon={RubkFaturamentoIcon}
          subscribeLink={subscribeLink}
          onClick={handleClose}
          showLicense={!Boolean(userPermissions?.faturamento)}
        />
        <MenuProductsItem
          description={"Rubk Orçamento"}
          Icon={RubkOrcamentoIcon}
          link={orcamentoLink}
          subscribeLink={subscribeLink}
          buttonClassName={classes.buttonOrcamento}
          showLicense={!Boolean(userPermissions?.orcamento)}
        />
      </SimpleMenu>
    </>
  );
};

export default MenuProducts;
